import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Books = () => {
  const [selectedDay, setSelectedDay] = useState(0);
  const [showExcerpt, setShowExcerpt] = useState(false);
  const [whatsappLink] = useState('https://chat.whatsapp.com/CreU1H442qQBIg84iMXEHb?mode=hqrt2');
  const { t } = useTranslation();

  // Icônes SVG inline
  const Icons = {
    Book: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
      </svg>
    ),
    Read: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
    Buy: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
      </svg>
    ),
    WhatsApp: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"/>
      </svg>
    ),
    Download: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
      </svg>
    ),
    Share: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
      </svg>
    ),
    Heart: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    ),
    Amazon: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.27 9.419C21.72 6.893 18.192 2.655 12 2.655S2.28 6.893.729 9.419a4.908 4.908 0 0 0 0 5.162C2.28 17.107 5.808 21.345 12 21.345s9.72-4.238 11.271-6.764a4.908 4.908 0 0 0 0-5.162zm-1.705 4.115C20.234 15.7 17.219 19.345 12 19.345S3.766 15.7 2.435 13.534a2.918 2.918 0 0 1 0-3.068C3.766 8.3 6.781 4.655 12 4.655s8.234 3.645 9.565 5.811a2.918 2.918 0 0 1 0 3.068zM12 7a5 5 0 1 0 5 5 5.006 5.006 0 0 0-5-5zm0 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3z"/>
      </svg>
    )
  };

  // Livre
  const book = {
    title: t('books.mainBook.title'),
    description: t('books.mainBook.description'),
    year: t('books.mainBook.year'),
    pages: t('books.mainBook.pages'),
    
    excerpt: t('books.mainBook.excerpt'),
    
    chapters: [
      { title: t('books.chapters.chapter1'), pages: t('books.chapters.pages1') },
      { title: t('books.chapters.chapter2'), pages: t('books.chapters.pages2') },
      { title: t('books.chapters.chapter3'), pages: t('books.chapters.pages3') },
      { title: t('books.chapters.chapter4'), pages: t('books.chapters.pages4') },
      { title: t('books.chapters.chapter5'), pages: t('books.chapters.pages5') },
      { title: t('books.chapters.chapter6'), pages: t('books.chapters.pages6') },
      { title: t('books.chapters.chapter7'), pages: t('books.chapters.pages7') },
      { title: t('books.chapters.chapter8'), pages: t('books.chapters.pages8') },
      { title: t('books.chapters.chapter9'), pages: t('books.chapters.pages9') },
      { title: t('books.chapters.chapter10'), pages: t('books.chapters.pages10') }
    ]
  };

  // Versets quotidiens
  const dailyVerses = [
    {
      day: t('books.verses.monday.day'),
      verse: t('books.verses.monday.verse'),
      text: t('books.verses.monday.text'),
      reflection: t('books.verses.monday.reflection')
    },
    {
      day: t('books.verses.tuesday.day'),
      verse: t('books.verses.tuesday.verse'),
      text: t('books.verses.tuesday.text'),
      reflection: t('books.verses.tuesday.reflection')
    },
    {
      day: t('books.verses.wednesday.day'),
      verse: t('books.verses.wednesday.verse'),
      text: t('books.verses.wednesday.text'),
      reflection: t('books.verses.wednesday.reflection')
    },
    {
      day: t('books.verses.thursday.day'),
      verse: t('books.verses.thursday.verse'),
      text: t('books.verses.thursday.text'),
      reflection: t('books.verses.thursday.reflection')
    },
    {
      day: t('books.verses.friday.day'),
      verse: t('books.verses.friday.verse'),
      text: t('books.verses.friday.text'),
      reflection: t('books.verses.friday.reflection')
    },
    {
      day: t('books.verses.saturday.day'),
      verse: t('books.verses.saturday.verse'),
      text: t('books.verses.saturday.text'),
      reflection: t('books.verses.saturday.reflection')
    },
    {
      day: t('books.verses.sunday.day'),
      verse: t('books.verses.sunday.verse'),
      text: t('books.verses.sunday.text'),
      reflection: t('books.verses.sunday.reflection')
    }
  ];

  // Articles
  const articles = [
    {
      title: t('books.articles.article1.title'),
      excerpt: t('books.articles.article1.excerpt'),
      readTime: t('books.articles.article1.readTime'),
      category: t('books.articles.article1.category')
    },
    {
      title: t('books.articles.article2.title'),
      excerpt: t('books.articles.article2.excerpt'),
      readTime: t('books.articles.article2.readTime'),
      category: t('books.articles.article2.category')
    },
    {
      title: t('books.articles.article3.title'),
      excerpt: t('books.articles.article3.excerpt'),
      readTime: t('books.articles.article3.readTime'),
      category: t('books.articles.article3.category')
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white pt-24">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black z-10"></div>
        <div 
          className="absolute inset-0 z-0 opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        
        <div className="container mx-auto px-4 relative z-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <div className="inline-flex items-center gap-3 mb-6">
              <h1 className="text-5xl md:text-7xl font-bold font-serif">
                {t('books.title')} <span className="text-yellow-600">& {t('books.titleHighlight')}</span>
              </h1>
            </div>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-3xl mx-auto">
              {t('books.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* SECTION DE LA GRANDE PHOTO */}
      <section className="py-12 bg-black relative">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-10"
          >
            <div className="inline-block text-yellow-400 text-sm font-semibold bg-black/80 backdrop-blur-sm px-6 py-3 rounded-full border border-yellow-500/30 mb-4">
              {t('books.clickInstruction')}
            </div>
            <p className="text-gray-400 text-sm max-w-md mx-auto">
              {t('books.bookDescription')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="flex justify-center items-center"
          >
            <div className="relative max-w-2xl w-full">
              <div className="absolute -inset-4 bg-gradient-to-r from-yellow-600/20 via-transparent to-purple-600/20 rounded-3xl blur-xl opacity-50"></div>
              
              <motion.div
                animate={{
                  rotateY: [0, 360],
                }}
                transition={{
                  rotateY: {
                    duration: 20,
                    repeat: Infinity,
                    ease: "linear"
                  }
                }}
                className="relative rounded-2xl overflow-hidden shadow-2xl cursor-pointer group"
                whileHover={{ scale: 1.02 }}
                onClick={() => window.open('https://a.co/d/8jzIkSN', '_blank')}
              >
                <img 
                  src="/assets/images/book.png" 
                  alt={t('books.bookAlt')}
                  className="w-full h-auto object-cover"
                />
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1 }}
                  className="absolute top-4 right-4"
                >
                  <motion.div
                    animate={{
                      y: [0, -10, 0],
                      rotate: [0, 5, 0, -5, 0],
                    }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      repeatDelay: 1
                    }}
                    className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-2xl"
                  >
                    <svg className="w-8 h-8 text-yellow-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"/>
                    </svg>
                  </motion.div>
                  
                  <motion.div
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ duration: 1.5, repeat: Infinity }}
                    className="absolute -top-2 -right-2 bg-yellow-600 text-white text-xs font-bold px-2 py-1 rounded-full whitespace-nowrap"
                  >
                    {t('books.click')}
                  </motion.div>
                </motion.div>
                
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.6 }}
                className="text-center mt-8"
              >
                
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
                className="absolute -bottom-20 left-1/2 transform -translate-x-1/2 text-center"
              >
                <motion.div
                  animate={{ y: [0, 10, 0] }}
                  transition={{ duration: 2, repeat: Infinity }}
                  className="text-gray-400"
                >
                  <div className="text-sm mb-2">↓</div>
                  <div className="text-xs text-gray-500">{t('books.continueReading')}</div>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Livre Principal */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('books.mainBookTitle')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('books.mainBookSubtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="flex items-start space-x-6 mb-8">
                <div className="w-32 h-40 bg-gradient-to-br from-yellow-600/20 to-yellow-800/20 rounded-2xl flex items-center justify-center border border-yellow-500/30">
                  <Icons.Book className="w-16 h-16 text-yellow-600" />
                </div>
                <div>
                  <h3 className="text-3xl font-bold text-white mb-3">
                    {book.title}
                  </h3>
                  <div className="flex flex-wrap gap-3 mb-4">
                    <span className="px-3 py-1 bg-gray-800 rounded-full text-sm">
                      {book.year}
                    </span>
                    <span className="px-3 py-1 bg-gray-800 rounded-full text-sm">
                      {book.pages}
                    </span>
                    <span className="px-3 py-1 bg-yellow-900/30 text-yellow-600 rounded-full text-sm">
                      {t('books.category')}
                    </span>
                  </div>
                  <p className="text-gray-300 leading-relaxed mb-6">
                    {book.description}
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <motion.a
                  href="https://a.co/d/8jzIkSN"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('books.amazonAria')}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="w-full bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-4 rounded-xl font-semibold hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300 flex items-center justify-center space-x-3"
                >
                  <Icons.Amazon className="w-5 h-5" />
                  <span>{t('books.amazonButton')}</span>
                </motion.a>

                <motion.button
                  onClick={() => setShowExcerpt(!showExcerpt)}
                  aria-label={showExcerpt ? t('books.hideExcerptAria') : t('books.readExcerptAria')}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="w-full border-2 border-yellow-600 text-yellow-600 py-4 rounded-xl font-semibold hover:bg-yellow-600 hover:text-black transition-all duration-300 flex items-center justify-center space-x-3"
                >
                  <Icons.Read className="w-5 h-5" />
                  <span>{showExcerpt ? t('books.hideExcerpt') : t('books.readExcerpt')}</span>
                </motion.button>
              </div>

              <AnimatePresence>
                {showExcerpt && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    className="mt-6 p-6 bg-gray-900/50 rounded-xl border border-yellow-500/30"
                  >
                    <div className="flex items-center space-x-2 mb-4">
                      <Icons.Read className="w-5 h-5 text-yellow-600" />
                      <span className="font-semibold text-yellow-600">{t('books.excerptTitle')}</span>
                    </div>
                    <p className="text-gray-300 italic leading-relaxed text-justify">
                      {book.excerpt}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="bg-gradient-to-b from-gray-900/50 to-black/50 rounded-3xl p-8 border border-gray-800"
            >
              <h4 className="text-xl font-bold text-white mb-6 flex items-center">
                <Icons.Book className="w-5 h-5 text-yellow-600 mr-2" />
                {t('books.tableOfContents')}
              </h4>
              <div className="space-y-4">
                {book.chapters.map((chapter, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="flex items-center justify-between p-4 rounded-xl bg-gray-900/30 hover:bg-gray-800/50 transition-all duration-300 group"
                  >
                    <div className="flex items-center space-x-4">
                      <div className="w-10 h-10 rounded-lg bg-yellow-500/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                        <span className="text-yellow-600 font-bold">{index + 1}</span>
                      </div>
                      <div>
                        <span className="text-white font-medium">{chapter.title}</span>
                        <p className="text-gray-400 text-sm">{chapter.pages}</p>
                      </div>
                    </div>
                    <Icons.Read className="w-5 h-5 text-gray-500 group-hover:text-yellow-600 transition-colors" />
                  </motion.div>
                ))}
              </div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="mt-8 p-6 bg-gradient-to-r from-green-900/20 to-green-800/10 rounded-xl border border-green-800/30"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-500/20 rounded-xl flex items-center justify-center">
                    <Icons.WhatsApp className="w-6 h-6 text-green-500" />
                  </div>
                  <div>
                    <h5 className="font-bold text-white">{t('books.studyGroup')}</h5>
                    <p className="text-gray-300 text-sm mb-3">
                      {t('books.studyGroupDesc')}
                    </p>
                    <a
                      href={whatsappLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-green-500 font-semibold hover:text-green-400 transition-colors"
                    >
                      {t('books.joinGroup')}
                      <span className="ml-2">→</span>
                    </a>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Parole du Jour */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('books.dailyWord')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('books.dailyWordSubtitle')}
            </p>
          </motion.div>

          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {dailyVerses.map((day, index) => (
              <motion.button
                key={day.day}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setSelectedDay(index)}
                className={`px-5 py-3 rounded-xl font-medium transition-all duration-300 ${
                  selectedDay === index
                    ? 'bg-yellow-600 text-white shadow-lg'
                    : 'bg-gray-900 text-gray-300 hover:bg-gray-800'
                }`}
              >
                {day.day}
              </motion.button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={selectedDay}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="max-w-3xl mx-auto"
            >
              <div className="bg-gradient-to-br from-gray-900/50 to-black/50 rounded-3xl p-8 md:p-12 border border-gray-800">
                <div className="text-center">
                  <div className="inline-block px-4 py-1 bg-yellow-500/20 rounded-full text-yellow-600 text-sm font-medium mb-6">
                    {dailyVerses[selectedDay].day}
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-6 font-serif">
                    {dailyVerses[selectedDay].verse}
                  </h3>
                  <div className="text-2xl text-gray-300 italic mb-8 leading-relaxed">
                    "{dailyVerses[selectedDay].text}"
                  </div>
                  <div className="p-4 bg-gray-900/30 rounded-xl border-l-4 border-yellow-600">
                    <p className="text-gray-300">{dailyVerses[selectedDay].reflection}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* Articles & Méditations */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold mb-4">
              {t('books.articlesTitle')}
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              {t('books.articlesSubtitle')}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <motion.article
                key={article.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -10 }}
                className="bg-gradient-to-b from-gray-900 to-black rounded-3xl p-8 border border-gray-800 hover:border-gray-700 transition-all duration-500 group"
              >
                <div className="mb-6">
                  <span className="inline-block px-3 py-1 bg-yellow-500/10 text-yellow-600 rounded-full text-sm font-medium">
                    {article.category}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-4 group-hover:text-yellow-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-gray-400 mb-6 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-6 border-t border-gray-800">
                  <div className="flex items-center space-x-2">
                    <span className="text-gray-500 text-sm">{article.readTime}</span>
                    <span className="text-xs px-2 py-1 bg-yellow-500/10 text-yellow-600 rounded-full">
                      {t('books.excerptLabel')}
                    </span>
                  </div>
                  <a
                    href="https://a.co/d/8jzIkSN"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-yellow-600 font-semibold hover:text-yellow-600 flex items-center group"
                    aria-label={`${t('books.readArticleAria')} "${article.title}"`}
                  >
                    {t('books.readArticle')}
                    <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                </div>
              </motion.article>
            ))}
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            viewport={{ once: true }}
            className="mt-12 text-center"
          >
            <a
              href="https://a.co/d/8jzIkSN"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-yellow-600 text-white rounded-xl font-semibold hover:bg-yellow-700 transition-all duration-300 hover:scale-105"
            >
              <Icons.Book className="w-5 h-5 mr-2" />
              {t('books.discoverAll')}
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Books;